import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLandlords,
  createUser,
  getUserProfile,
} from "../thunks/userThunks";

const userSlice = createSlice({
  name: "user",
  initialState: {
    list: [],
    profile: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandlords.fulfilled, (state, action) => {
        console.log("Fetched landlord data:", action.payload);
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.list.push(action.payload);
        console.log("User created successfully:", action.payload);
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
      });
  },
});

export default userSlice.reducer;
